<template>
  <div class="d-flex configurator-nav border-left border-right border-top border-configurator">
    <navigation-bar-item 
      to="/patch-cord" 
      :disabled="$store.state.navigationDisabled.patchCord" 
      v-if="$store.state.enabledConfiguratorTypes.patchcord"
    >
      {{ $t('patchCord') }}
    </navigation-bar-item>

    <navigation-bar-item 
      to="/breakout" 
      :disabled="$store.state.navigationDisabled.breakout" 
      v-if="$store.state.enabledConfiguratorTypes.breakout"
    >
      {{ $t('breakout') }}
    </navigation-bar-item>

    <navigation-bar-item 
      to="/trunk" 
      :disabled="$store.state.navigationDisabled.trunk" 
      v-if="$store.state.enabledConfiguratorTypes.trunk"
    >
      {{ $t('trunk') }}
    </navigation-bar-item>

    <!-- Cake tab -->
    <!-- <a 
      href="#" 
      class="nav-item px-3 py-3 border-right border-light text-uppercase fw-bold text-center w-25"
      v-if="userSource !== 'digikey'"
      @click.prevent="handleCakeClick"
    >
      {{ $t('cake') }}
    </a> -->

    <a 
      v-if="$store.state.enabledConfiguratorTypes.fbgs"
      href="/config/fbgs"
      class="nav-item px-3 py-3 border-right border-light w-25"
    >
      FBGS
    </a>
  </div>
</template>

<script>
import NavigationBarItem from './NavigationBarItem'

export default {
  components: {
    NavigationBarItem
  },
  data() {
    return {
      userSource: "",
      validVoucher: "amphenolsachsenkabel" // ✅ Random voucher code (hardcoded for now)
    }
  },
  mounted() {
    this.userSource = localStorage.getItem("userSource");
  },
  methods: {
    // handleCakeClick() {
    //   const enteredCode = prompt("Please enter your voucher code to access Cake Configurator:");

    //   if (enteredCode === null) {
    //     // user cancelled
    //     return;
    //   }

    //   if (enteredCode.trim() === this.validVoucher) {
    //     // ✅ Voucher matched, proceed to Cake page
    //     this.$router.push("/cake");
    //   } else {
    //     // ❌ Invalid code
    //     alert("Invalid voucher code. Please try again.");
    //   }
    // }
  }
}
</script>

<style lang="scss">
.configurator-nav {
  background-color: $eee;
}

/* Desktop */
@media (min-width: 960px) {
  .nav-item {
    color: #6c757d !important;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: 600;
    min-width: 10em;
    text-align: center;
    cursor: pointer;
  }

  .nav-item:not(.active):hover {
    background-color: $darker-eee;
  }

  .nav-item.active {
    text-decoration: none;
  }

  .nav-item.hidden {
    color: transparent;
    pointer-events: none;
  }

  .nav-item:last-child {
    border-right: 0 none !important;
  }
}
</style>
